module.exports = "pegasus_template/assets/hexline-tumblr.png";